import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { MaterialApi } from './apis/material-api';
import { MaterialApiImpl } from './apis/impls/material-api';
import { DocAnalyzerApi } from './apis/doc-analyzer-api';
import { DocAnalyzerApiImpl } from './apis/impls/doc-analyzer-api';
import { MaterialFormulationApi } from './apis/formulation-api';
import { MaterialFormulationApiImpl } from './apis/impls/formulation-api';
import { ReverseEngineeringApi } from './apis/re-api';
import { ReverseEngineeringApiImpl } from './apis/impls/re-api';

export const materialContainer = new ContainerModule((bind) => {
  bind(MaterialApi).to(MaterialApiImpl);
  bind(DocAnalyzerApi).to(DocAnalyzerApiImpl);
  bind(MaterialFormulationApi).to(MaterialFormulationApiImpl);
  bind(ReverseEngineeringApi).to(ReverseEngineeringApiImpl);
});
